import { render, staticRenderFns } from "./SysDataSourceList.vue?vue&type=template&id=6da2a770&scoped=true&"
import script from "./SysDataSourceList.vue?vue&type=script&lang=js&"
export * from "./SysDataSourceList.vue?vue&type=script&lang=js&"
import style0 from "./SysDataSourceList.vue?vue&type=style&index=0&id=6da2a770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2a770",
  null
  
)

export default component.exports